// extracted by mini-css-extract-plugin
export default {"controls":"NameEdit_controls__R7cxO","field":"NameEdit_field__1nI1o","wrapper":"NameEdit_wrapper__hWoRH"};